<template>
    <div class="main">
        <c-panel :title="titulo" :titleIcon="icone">
            <painel></painel>
        </c-panel>
    </div>
</template>
<script>
import painel from "./painel"
export default {
    components: { painel },
    data () { return { titulo: '', icone: '' } },
    created () {
        this.titulo = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : ''
        this.icone = 'fas fa-chart-line'
    }
}
</script>
